import React from "react";
import { Modal, Button, ModalBody, ModalHeader } from "reactstrap";

export default function ShowYTMModal(props) {
  return (
    <div className="ytm-modal">
      <Modal
        centered
        isOpen={props.showYTM}
        toggle={props.closeYTMModal}
        className="modal-md"
        backdropClassName="faded-backdrop"
      >
        <ModalHeader toggle={props.closeYTMModal} className="pt-3"></ModalHeader>
        <ModalBody className="text-center px-4 pb-4">
          <div className="mt-4" style={{ textAlign: "center" }}>
            <b className="font-size-16">
            YTM is based on the offer applicable for you: {props?.YTM ? props.YTM : "NA"} (Current Yield) 
            </b>
            <br/>
          </div>
        </ModalBody>
      </Modal>
    </div>
  );
};
